import { supabase } from './supabase.js';

/** Mínimo tiempo entre dos eventos idénticos usuario+zona (debounce cliente). */
const MIN_MS = 22000;
const lastTs = {};

/**
 * Registra una visita a una zona lógica de la app (métricas agregadas en admin).
 * No bloquea UI; fallos silenciosos salvo consola.
 */
export function logSiteZone(userId, zone) {
  if (!userId || !zone) return;
  if (typeof window === 'undefined') return;
  const key = `${userId}::${String(zone)}`;
  const now = Date.now();
  if (lastTs[key] && now - lastTs[key] < MIN_MS) return;
  lastTs[key] = now;
  void supabase.from('user_site_analytics').insert({ user_id: userId, zone: String(zone).slice(0, 80) }).then(({ error }) => {
    if (error && process.env.NODE_ENV === 'development') {
      console.warn('[userAnalytics]', error.message);
    }
  });
}
